import "./App.css";
import { AppBarHeader } from "./component/Header/AppBarHeader";
import RouterApp from "./component/Router/RouterApp";
function App() {
  return (
    <div>
      <AppBarHeader />
      <RouterApp />
    </div>
  );
}

export default App;
